export class ForgottenPasswordDto {
    email: string;
}

export class ResetPasswordDto {
    token: string;
    password: string;
    confirmPassword: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/userAccounts/userAccount.models.ts